'use client';

import Image from 'next/image';
import { useWindowSize } from 'usehooks-ts';

import UiUtils from '@utils/ui';
import { ResourceType } from '@constants/resource';

import Tag from '@components/tag';

export default function HomeResourceBlock(props) {
    const { type, tags, title, text, link, image, ...otherProps } = props;

    const { width } = useWindowSize();
    const isMobile = UiUtils.isMobile(width);

    let imageClass = "w-full rounded-xl object-cover";
    imageClass = isMobile ? `h-[211px] ${imageClass}` : `h-[332px] ${imageClass}`;

    return (
        <div>
            <a href={link} className="no-underline!" aria-label={UiUtils.getResourceAriaLabel(type, title)}>
                <div className="flex flex-col items-stretch">
                    {image && (
                        <Image 
                            src={image.url} 
                            width={image.width}
                            height={image.height}
                            className={imageClass} 
                            alt={image.alt}
                        />
                    )}
                    <div 
                        className="flex flex-col items-stretch justify-between h-full w-full p-6 grow"
                        { ...otherProps }
                    >
                        <div className="flex flex-col items-start gap-4 grow">
                            <div className="flex gap-4">
                                {tags.map((tag, index) => (
                                    <Tag key={`tag-${index}`} text={tag.text} color={tag.color}/>
                                ))}
                            </div>
                            <h3 className="font-vg-medium text-2xl leading-120 text-black">{title}</h3>
                            <p 
                                className="font-vg-book text-base leading-130 text-black line-clamp-2"
                                dangerouslySetInnerHTML={{__html: text}}
                            />
                        </div>
                        <div>
                            {type === ResourceType.VIDEO ? (
                                <p className="font-vg-regular text-blue text-base leading-8 underline">Watch now</p>
                            ) : (
                                <p className="font-vg-regular text-blue text-base leading-8 underline">Read more</p>
                            )}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}